import { render, staticRenderFns } from "./customInputTwo.vue?vue&type=template&id=5607afa5&scoped=true"
import script from "./customInputTwo.vue?vue&type=script&lang=js"
export * from "./customInputTwo.vue?vue&type=script&lang=js"
import style0 from "./customInputTwo.vue?vue&type=style&index=0&id=5607afa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607afa5",
  null
  
)

export default component.exports